import { __rest } from '../../_virtual/_tslib.js';
import { CardsCheckboxesItemPresentation } from '@lsg/shared';
import React from 'react';

// TODO: remove `look` default value after next major release as per deprecation.
var CardsCheckboxesItem = function CardsCheckboxesItem(_a) {
  var _a$look = _a.look,
    look = _a$look === void 0 ? "checkbox" : _a$look,
    _a$thumbPosition = _a.thumbPosition,
    thumbPosition = _a$thumbPosition === void 0 ? "bottom" : _a$thumbPosition,
    props = __rest(_a, ["look", "thumbPosition"]);
  return /*#__PURE__*/React.createElement(CardsCheckboxesItemPresentation, Object.assign({}, Object.assign({
    look: look,
    thumbPosition: thumbPosition
  }, props)));
};
CardsCheckboxesItem.displayName = "Cards.Checkboxes.Item";

export { CardsCheckboxesItem };
